import TidyOptBar from 'components/dot/bar/tidy-opt-bar';
import CellTidyList from 'components/list/cell-tidy-list';
import { useEffect, useState } from 'react';

import { Toast } from 'antd-mobile';
import { VideoListType } from 'app/constant';
import NoDataTip from 'components/dot/no-data-tip';
import { CellTidyDataType } from 'components/item/cell-tidy';
import { useI18n } from 'i18n/useI18n';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { VideoDataType } from 'services/apis/cnt/video-api';
import VideoListApi from 'services/apis/usr/video-list-api';
import { bizBaseUrl } from 'services/request';
import { setList } from 'stores/historySlice';
import { scrollTop } from 'utils/screenUtil';

export default function UserHistory(props: { historyListId: string }) {
  const { t } = useI18n();
  const [tidyStatus, handleTidyStatus] = useState(false);

  const historyList = useSelector((state: any) => state.historyListHandle.value);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchList = async (listId: string) => {
    const result = await VideoListApi.listWithType(listId, []);
    if (result.code === 0 && result.successful) {
      const dataList: CellTidyDataType[] = [];
      (result.result as VideoDataType[])?.forEach((item, index) => {
        dataList.push({
          postUuid: item.postUuid,
          postTitle: item.postTitle,
          postCover: item.postCoverUrl?.replaceAll('\\', '/').replaceAll('D:/_Resource/', bizBaseUrl + '/images/'),
          postSourceType: item.postSourceType,
          termUuid: item.termUuid,
          isCollect: false,
          isRemove: false,
          showMask: false,
          handleRemove: () => {},
        } as CellTidyDataType);
      });
      dispatch(setList(dataList));
      console.log('dataList', dataList);
    } else {
      Toast.show(t('history.index.863805-0'));
    }
  };

  useEffect(() => {
    if (props.historyListId) {
      fetchList(props.historyListId);
    }
  }, [props.historyListId]);

  return (
    <div className=" mt-2">
      <TidyOptBar
        name={t('history.index.863805-1')}
        tidyStatus={tidyStatus}
        handleStatus={handleTidyStatus}
        videoListId={props.historyListId}
        videoListType={'history'}
      />
      {historyList.length === 0 ? (
        <NoDataTip />
      ) : (
        <>
          <div className=" mt-2">
            <CellTidyList
              column={3}
              tidyStatus={tidyStatus} //0 关闭整理 1 开启整理 显示遮罩
              handleTidyStatus={handleTidyStatus}
              cellTidyList={historyList}
            />
          </div>
        </>
      )}
    </div>
  );
}
